// @ts-check

/**
 * @typedef {Object} createAddressObj_FoundAddressType
 * @property {string} address_id
 * @property {string} street
 * @property {string} city
 * @property {string} province
 * @property {string} postalCode
 * @property {string} country
 * @property {string} placeId
 * @property {string} type
 * @property {string} lat
 * @property {string} lng
 * @property {string} unit
 */

/**
 * @typedef {Object} createAddressObj_ReturnType
 * @property {string} address_id
 * @property {string} street
 * @property {string} city
 * @property {string} province
 * @property {string} postalCode
 * @property {string} country
 * @property {string} placeId
 * @property {string} type
 * @property {string} lat
 * @property {string} lng
 */

/**
 * @function createAddressObj
 * @param {createAddressObj_FoundAddressType} foundAddress
 * @param {object} payload
 * @param {string} addressType
 * @returns {createAddressObj_ReturnType}
 */
function createAddressObj(foundAddress, payload, addressType) {
	if (!payload || !payload.geoCode || !payload.geoCode[0]) {
		throw new Error('Invalid payload structure.');
	}

	const geoCode = payload.geoCode[0];
	const addressComp = geoCode.address_components;
	const coordinate = payload.latLng;

	let initAddress = {
		address_id: foundAddress ? foundAddress.address_id : '',
		type: addressType,
		placeId: String(geoCode.place_id),
		street: '',
		city: '',
		province: '',
		country: '',
		postalCode: '',
		lat: String(coordinate.lat),
		lng: String(coordinate.lng),
	};

	/** @type {createAddressObj_ReturnType} */
	const finalAddressObj = addressComp.reduce((acc, component) => {
		const type = component.types[0];
		const value = component.short_name;

		switch (type) {
			case 'street_number':
				return { ...acc, street: value };
			case 'route':
				const unit = payload.unit ? `, ${payload.unit}` : '';
				return { ...acc, street: `${acc.street} ${value}${unit}`.trim() };
			case 'locality':
				return { ...acc, city: value };
			case 'administrative_area_level_1':
				return { ...acc, province: value };
			case 'country':
				return { ...acc, country: value };
			case 'postal_code':
				return { ...acc, postalCode: value };
			default:
				return acc;
		}
	}, initAddress);

	return finalAddressObj;
}

export default createAddressObj;
